import { __decorate, __param } from 'tslib';
import { InjectionToken, Optional, Self, Inject, ChangeDetectorRef, ViewChild, Input, HostBinding, Component, ChangeDetectionStrategy, forwardRef, Directive, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AbstractTuiControl, isNativeFocused, isPresent, setNativeFocused, clamp, TUI_IS_MOBILE, tuiDefaultProp, tuiPure, TUI_FOCUSABLE_ITEM_ACCESSOR } from '@taiga-ui/cdk';
import { tuiCreateNumberMask, formatNumber, TUI_TEXTFIELD_APPEARANCE, TuiTextfieldSizeDirective, TUI_TEXTFIELD_SIZE, TUI_NUMBER_FORMAT, TuiPrimitiveTextfieldComponent, TuiAbstractTextfieldHost, TUI_TEXTFIELD_HOST, TuiButtonModule, TuiPrimitiveTextfieldModule, TuiTextfieldControllerModule, TuiTextfieldComponent } from '@taiga-ui/core';
import { TUI_PLUS_MINUS_TEXTS } from '@taiga-ui/kit/tokens';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TuiValueAccessorModule } from '@taiga-ui/kit/directives';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { TextMaskModule } from 'angular2-text-mask';

// TODO: remove in ivy compilation
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core';
import * as ɵngcc2 from '@taiga-ui/kit/directives';
import * as ɵngcc3 from 'angular2-text-mask';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from 'rxjs';

function TuiInputCountComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "section", 2);
    ɵngcc0.ɵɵelementStart(2, "button", 3);
    ɵngcc0.ɵɵlistener("mousedown", function TuiInputCountComponent_ng_container_3_ng_container_1_Template_button_mousedown_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onButtonMouseDown($event, ctx_r3.plusButtonDisabled); })("click", function TuiInputCountComponent_ng_container_3_ng_container_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.increaseValue(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵlistener("mousedown", function TuiInputCountComponent_ng_container_3_ng_container_1_Template_button_mousedown_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onButtonMouseDown($event, ctx_r6.minusButtonDisabled); })("click", function TuiInputCountComponent_ng_container_3_ng_container_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.decreaseValue(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const texts_r2 = ctx.ngIf;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r1.iconUp)("appearance", ctx_r1.options.appearance)("title", texts_r2[0])("disabled", ctx_r1.plusButtonDisabled)("focusable", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r1.iconDown)("appearance", ctx_r1.options.appearance)("disabled", ctx_r1.minusButtonDisabled)("focusable", false)("title", texts_r2[1]);
} }
function TuiInputCountComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiInputCountComponent_ng_container_3_ng_container_1_Template, 4, 10, "ng-container", 1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.minusTexts$));
} }
const _c0 = ["*", [["input"]]];
const _c1 = ["*", "input"];
const PASSWORD_ICON_UP = 'tuiIconPlus';
const PASSWORD_ICON_DOWN = 'tuiIconMinus';
/** Default values for the input count options. */
const TUI_INPUT_COUNT_DEFAULT_OPTIONS = {
    icons: {
        up: PASSWORD_ICON_UP,
        down: PASSWORD_ICON_DOWN,
    },
    appearance: 'textfield',
    hideButtons: false,
    min: 0,
    max: Infinity,
    step: 1,
    postfix: '',
};
const TUI_INPUT_COUNT_OPTIONS = new InjectionToken('Default parameters for input count component', {
    factory: () => TUI_INPUT_COUNT_DEFAULT_OPTIONS,
});
const tuiInputCountOptionsProvider = (options) => ({
    provide: TUI_INPUT_COUNT_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_INPUT_COUNT_DEFAULT_OPTIONS), options),
});

var TuiInputCountComponent_1;
// @dynamic
let TuiInputCountComponent = TuiInputCountComponent_1 = class TuiInputCountComponent extends AbstractTuiControl {
    constructor(control, changeDetectorRef, appearance, textfieldSize, minusTexts$, isMobile, options, numberFormat) {
        super(control, changeDetectorRef);
        this.appearance = appearance;
        this.textfieldSize = textfieldSize;
        this.minusTexts$ = minusTexts$;
        this.isMobile = isMobile;
        this.options = options;
        this.numberFormat = numberFormat;
        this.step = this.options.step;
        this.min = this.options.min;
        this.max = this.options.max;
        this.hideButtons = this.options.hideButtons;
        this.prefix = '';
        this.postfix = this.options.postfix;
    }
    getMask(allowNegative) {
        return {
            mask: tuiCreateNumberMask({
                allowNegative,
                decimalSymbol: this.numberFormat.decimalSeparator,
                thousandSymbol: this.numberFormat.thousandSeparator,
            }),
            guide: false,
        };
    }
    // TODO: Remove in v.3
    get buttonsHidden() {
        return this.hideButtons || this.appearance === 'table';
    }
    get iconUp() {
        return this.options.icons.up;
    }
    get iconDown() {
        return this.options.icons.down;
    }
    get nativeFocusableElement() {
        return !this.primitiveTextfield || this.computedDisabled
            ? null
            : this.primitiveTextfield.nativeFocusableElement;
    }
    get size() {
        return this.textfieldSize.size;
    }
    get focused() {
        return isNativeFocused(this.nativeFocusableElement);
    }
    get exampleText() {
        return String(this.min);
    }
    get computedValue() {
        return this.focused ? this.nativeValue : this.formatNumber(this.value);
    }
    get minusButtonDisabled() {
        return !this.interactive || (isPresent(this.value) && this.value <= this.min);
    }
    get plusButtonDisabled() {
        return !this.interactive || (isPresent(this.value) && this.value >= this.max);
    }
    onButtonMouseDown(event, disabled = false) {
        if (disabled || !this.nativeFocusableElement || this.isMobile) {
            return;
        }
        event.preventDefault();
        setNativeFocused(this.nativeFocusableElement);
    }
    onFocused(focused) {
        if (!focused) {
            this.onBlur();
        }
        this.updateFocused(focused);
    }
    onHovered(hovered) {
        this.updateHovered(hovered);
    }
    onPressed(pressed) {
        this.updatePressed(pressed);
    }
    onValueChange() {
        const capped = this.capValue(this.nativeNumberValue);
        if (capped === null || isNaN(capped)) {
            return;
        }
        const newValue = this.formatNumber(capped);
        if (this.nativeValue !== newValue) {
            this.nativeValue = newValue;
        }
        this.updateValue(capped);
    }
    decreaseValue() {
        if (this.readOnly) {
            return;
        }
        const newValue = (this.value || 0) - this.step;
        this.safeUpdateValue(newValue);
    }
    increaseValue() {
        if (this.readOnly) {
            return;
        }
        const newValue = (this.value || 0) + this.step;
        this.safeUpdateValue(newValue);
    }
    onKeydown(event) {
        switch (event.key) {
            case 'ArrowUp':
            case 'Up':
                this.increaseValue();
                event.preventDefault();
                break;
            case 'ArrowDown':
            case 'Down':
                this.decreaseValue();
                event.preventDefault();
                break;
            default:
                break;
        }
    }
    getFallbackValue() {
        return 0;
    }
    get nativeNumberValue() {
        return parseInt(this.nativeValue.split(this.numberFormat.thousandSeparator).join(''), 10);
    }
    get nativeValue() {
        return this.nativeFocusableElement ? this.nativeFocusableElement.value : '';
    }
    set nativeValue(value) {
        if (!this.nativeFocusableElement) {
            return;
        }
        this.nativeFocusableElement.value = value;
    }
    safeUpdateValue(newValue) {
        const value = clamp(newValue, this.min, this.max);
        this.updateValue(value);
        this.nativeValue = this.formatNumber(value);
    }
    capValue(value) {
        const capped = Math.min(value, this.max);
        return isNaN(capped) || capped < this.min ? null : capped;
    }
    onBlur() {
        const value = Math.max(this.nativeNumberValue || 0, this.min);
        const formattedValue = this.formatNumber(value);
        this.nativeValue = formattedValue;
        this.updateValue(value);
        if (this.primitiveTextfield) {
            this.primitiveTextfield.value = formattedValue;
        }
    }
    formatNumber(value) {
        return formatNumber(value, null, this.numberFormat.decimalSeparator, this.numberFormat.thousandSeparator);
    }
};
TuiInputCountComponent.ɵfac = function TuiInputCountComponent_Factory(t) { return new (t || TuiInputCountComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TUI_TEXTFIELD_APPEARANCE), ɵngcc0.ɵɵdirectiveInject(TUI_TEXTFIELD_SIZE), ɵngcc0.ɵɵdirectiveInject(TUI_PLUS_MINUS_TEXTS), ɵngcc0.ɵɵdirectiveInject(TUI_IS_MOBILE), ɵngcc0.ɵɵdirectiveInject(TUI_INPUT_COUNT_OPTIONS), ɵngcc0.ɵɵdirectiveInject(TUI_NUMBER_FORMAT)); };
TuiInputCountComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiInputCountComponent, selectors: [["tui-input-count"]], viewQuery: function TuiInputCountComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiPrimitiveTextfieldComponent, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.primitiveTextfield = _t.first);
    } }, hostVars: 3, hostBindings: function TuiInputCountComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-size", ctx.size);
        ɵngcc0.ɵɵclassProp("_hide-buttons", ctx.buttonsHidden);
    } }, inputs: { step: "step", min: "min", max: "max", hideButtons: "hideButtons", prefix: "prefix", postfix: "postfix" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiInputCountComponent_1)
            },
            {
                provide: AbstractTuiControl,
                useExisting: forwardRef(() => TuiInputCountComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 4, vars: 14, consts: [["tuiValueAccessor", "", "tuiTextfieldAutocomplete", "off", "tuiTextfieldInputMode", "numeric", 1, "textfield", 3, "tuiTextfieldMaxLength", "pseudoFocused", "pseudoHovered", "pseudoPressed", "focusable", "nativeId", "prefix", "postfix", "disabled", "readOnly", "textMask", "invalid", "value", "valueChange", "keydown", "focusedChange", "hoveredChange", "pressedChange"], [4, "ngIf"], [1, "buttons"], ["tuiIconButton", "", "type", "button", "automation-id", "tui-input-count__plus-button", "size", "s", 1, "button", "button_plus", 3, "icon", "appearance", "title", "disabled", "focusable", "mousedown", "click"], ["tuiIconButton", "", "type", "button", "automation-id", "tui-input-count__minus-button", "size", "s", 1, "button", "button_minus", 3, "icon", "appearance", "disabled", "focusable", "title", "mousedown", "click"]], template: function TuiInputCountComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementStart(0, "tui-primitive-textfield", 0);
        ɵngcc0.ɵɵlistener("valueChange", function TuiInputCountComponent_Template_tui_primitive_textfield_valueChange_0_listener() { return ctx.onValueChange(); })("keydown", function TuiInputCountComponent_Template_tui_primitive_textfield_keydown_0_listener($event) { return ctx.onKeydown($event); })("focusedChange", function TuiInputCountComponent_Template_tui_primitive_textfield_focusedChange_0_listener($event) { return ctx.onFocused($event); })("hoveredChange", function TuiInputCountComponent_Template_tui_primitive_textfield_hoveredChange_0_listener($event) { return ctx.onHovered($event); })("pressedChange", function TuiInputCountComponent_Template_tui_primitive_textfield_pressedChange_0_listener($event) { return ctx.onPressed($event); });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵprojection(2, 1, ["ngProjectAs", "input", 5, ["input"]]);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, TuiInputCountComponent_ng_container_3_Template, 3, 3, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("tuiTextfieldMaxLength", 18)("pseudoFocused", ctx.pseudoFocused)("pseudoHovered", ctx.pseudoHovered)("pseudoPressed", ctx.pseudoPressed)("focusable", ctx.focusable)("nativeId", ctx.nativeId)("prefix", ctx.prefix)("postfix", ctx.postfix)("disabled", ctx.computedDisabled)("readOnly", ctx.readOnly)("textMask", ctx.getMask(ctx.min < 0))("invalid", ctx.computedInvalid)("value", ctx.computedValue);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.buttonsHidden);
    } }, directives: [ɵngcc1.TuiPrimitiveTextfieldComponent, ɵngcc1.TuiPrimitiveTextfieldDirective, ɵngcc2.TuiValueAccessorDirective, ɵngcc1.TuiTextfieldAutocompleteDirective, ɵngcc1.TuiTextfieldInputModeDirective, ɵngcc1.TuiTextfieldMaxLengthDirective, ɵngcc3.MaskedInputDirective, ɵngcc4.NgIf, ɵngcc1.TuiButtonComponent], pipes: [ɵngcc4.AsyncPipe], styles: ["[_nghost-%COMP%]{display:flex;font:var(--tui-font-text-s);border-radius:var(--tui-radius-m);height:var(--tui-height-m);color:var(--tui-text-01);text-align:left}._disabled[_nghost-%COMP%]{pointer-events:none}[data-size='l'][_nghost-%COMP%]{font:var(--tui-font-text-m);height:var(--tui-height-l)}.textfield[_ngcontent-%COMP%]{position:relative;border-radius:inherit;text-align:inherit;flex-grow:1;min-width:0}[_nghost-%COMP%]:not(._hide-buttons)   .textfield[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}.buttons[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-left:.125rem;height:100%}.buttons[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{display:flex;width:calc(var(--tui-height-m) * .75);height:calc(50% - .0625rem)}.buttons[_ngcontent-%COMP%]   .button_plus[_ngcontent-%COMP%]{margin-bottom:.125rem;border-radius:0 var(--tui-radius-m) 0 0}.buttons[_ngcontent-%COMP%]   .button_minus[_ngcontent-%COMP%]{border-radius:0 0 var(--tui-radius-m)}[data-size='l'][_nghost-%COMP%]   .buttons[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{width:calc(var(--tui-height-l) * .75)}"], changeDetection: 0 });
TuiInputCountComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: String, decorators: [{ type: Inject, args: [TUI_TEXTFIELD_APPEARANCE,] }] },
    { type: TuiTextfieldSizeDirective, decorators: [{ type: Inject, args: [TUI_TEXTFIELD_SIZE,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_PLUS_MINUS_TEXTS,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_MOBILE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_INPUT_COUNT_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_NUMBER_FORMAT,] }] }
];
__decorate([
    ViewChild(TuiPrimitiveTextfieldComponent)
], TuiInputCountComponent.prototype, "primitiveTextfield", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputCountComponent.prototype, "step", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputCountComponent.prototype, "min", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputCountComponent.prototype, "max", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputCountComponent.prototype, "hideButtons", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputCountComponent.prototype, "prefix", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputCountComponent.prototype, "postfix", void 0);
__decorate([
    tuiPure
], TuiInputCountComponent.prototype, "getMask", null);
__decorate([
    HostBinding('class._hide-buttons')
], TuiInputCountComponent.prototype, "buttonsHidden", null);
__decorate([
    HostBinding('attr.data-size')
], TuiInputCountComponent.prototype, "size", null);
TuiInputCountComponent = TuiInputCountComponent_1 = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(ChangeDetectorRef)),
    __param(2, Inject(TUI_TEXTFIELD_APPEARANCE)),
    __param(3, Inject(TUI_TEXTFIELD_SIZE)),
    __param(4, Inject(TUI_PLUS_MINUS_TEXTS)),
    __param(5, Inject(TUI_IS_MOBILE)),
    __param(6, Inject(TUI_INPUT_COUNT_OPTIONS)),
    __param(7, Inject(TUI_NUMBER_FORMAT))
], TuiInputCountComponent);

var TuiInputCountDirective_1;
let TuiInputCountDirective = TuiInputCountDirective_1 = class TuiInputCountDirective extends TuiAbstractTextfieldHost {
    onValueChange() {
        this.host.onValueChange();
    }
    process(input) {
        input.autocomplete = 'off';
        input.inputMode = 'numeric';
    }
};
TuiInputCountDirective.ɵfac = function TuiInputCountDirective_Factory(t) { return ɵTuiInputCountDirective_BaseFactory(t || TuiInputCountDirective); };
TuiInputCountDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiInputCountDirective, selectors: [["tui-input-count"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_HOST,
                useExisting: forwardRef(() => TuiInputCountDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });

let TuiInputCountModule = class TuiInputCountModule {
};
TuiInputCountModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiInputCountModule });
TuiInputCountModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiInputCountModule_Factory(t) { return new (t || TuiInputCountModule)(); }, imports: [[
            CommonModule,
            TextMaskModule,
            TuiButtonModule,
            TuiPrimitiveTextfieldModule,
            TuiTextfieldControllerModule,
            TuiValueAccessorModule,
            PolymorpheusModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiInputCountComponent, [{
        type: Component,
        args: [{
                selector: 'tui-input-count',
                template: "<tui-primitive-textfield\n    tuiValueAccessor\n    tuiTextfieldAutocomplete=\"off\"\n    tuiTextfieldInputMode=\"numeric\"\n    class=\"textfield\"\n    [tuiTextfieldMaxLength]=\"18\"\n    [pseudoFocused]=\"pseudoFocused\"\n    [pseudoHovered]=\"pseudoHovered\"\n    [pseudoPressed]=\"pseudoPressed\"\n    [focusable]=\"focusable\"\n    [nativeId]=\"nativeId\"\n    [prefix]=\"prefix\"\n    [postfix]=\"postfix\"\n    [disabled]=\"computedDisabled\"\n    [readOnly]=\"readOnly\"\n    [textMask]=\"getMask(min < 0)\"\n    [invalid]=\"computedInvalid\"\n    [value]=\"computedValue\"\n    (valueChange)=\"onValueChange()\"\n    (keydown)=\"onKeydown($event)\"\n    (focusedChange)=\"onFocused($event)\"\n    (hoveredChange)=\"onHovered($event)\"\n    (pressedChange)=\"onPressed($event)\"\n>\n    <ng-content></ng-content>\n    <ng-content select=\"input\" ngProjectAs=\"input\"></ng-content>\n</tui-primitive-textfield>\n<ng-container *ngIf=\"!buttonsHidden\">\n    <ng-container *ngIf=\"minusTexts$ | async as texts\">\n        <section class=\"buttons\">\n            <button\n                tuiIconButton\n                type=\"button\"\n                automation-id=\"tui-input-count__plus-button\"\n                size=\"s\"\n                class=\"button button_plus\"\n                [icon]=\"iconUp\"\n                [appearance]=\"options.appearance\"\n                [title]=\"texts[0]\"\n                [disabled]=\"plusButtonDisabled\"\n                [focusable]=\"false\"\n                (mousedown)=\"onButtonMouseDown($event, plusButtonDisabled)\"\n                (click)=\"increaseValue()\"\n            ></button>\n            <button\n                tuiIconButton\n                type=\"button\"\n                automation-id=\"tui-input-count__minus-button\"\n                size=\"s\"\n                class=\"button button_minus\"\n                [icon]=\"iconDown\"\n                [appearance]=\"options.appearance\"\n                [disabled]=\"minusButtonDisabled\"\n                [focusable]=\"false\"\n                [title]=\"texts[1]\"\n                (mousedown)=\"onButtonMouseDown($event, minusButtonDisabled)\"\n                (click)=\"decreaseValue()\"\n            ></button>\n        </section>\n    </ng-container>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiInputCountComponent_1)
                    },
                    {
                        provide: AbstractTuiControl,
                        useExisting: forwardRef(() => TuiInputCountComponent_1)
                    },
                ],
                styles: [":host{display:flex;font:var(--tui-font-text-s);border-radius:var(--tui-radius-m);height:var(--tui-height-m);color:var(--tui-text-01);text-align:left}:host._disabled{pointer-events:none}:host[data-size='l']{font:var(--tui-font-text-m);height:var(--tui-height-l)}.textfield{position:relative;border-radius:inherit;text-align:inherit;flex-grow:1;min-width:0}:host:not(._hide-buttons) .textfield{border-top-right-radius:0;border-bottom-right-radius:0}.buttons{display:flex;flex-direction:column;margin-left:.125rem;height:100%}.buttons .button{display:flex;width:calc(var(--tui-height-m) * .75);height:calc(50% - .0625rem)}.buttons .button_plus{margin-bottom:.125rem;border-radius:0 var(--tui-radius-m) 0 0}.buttons .button_minus{border-radius:0 0 var(--tui-radius-m)}:host[data-size='l'] .buttons .button{width:calc(var(--tui-height-l) * .75)}"]
            }]
    }], function () { return [{ type: ɵngcc5.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [TUI_TEXTFIELD_APPEARANCE]
            }] }, { type: ɵngcc1.TuiTextfieldSizeDirective, decorators: [{
                type: Inject,
                args: [TUI_TEXTFIELD_SIZE]
            }] }, { type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [TUI_PLUS_MINUS_TEXTS]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_MOBILE]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_INPUT_COUNT_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_NUMBER_FORMAT]
            }] }]; }, { step: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], hideButtons: [{
            type: Input
        }], prefix: [{
            type: Input
        }], postfix: [{
            type: Input
        }], buttonsHidden: [{
            type: HostBinding,
            args: ['class._hide-buttons']
        }], size: [{
            type: HostBinding,
            args: ['attr.data-size']
        }], primitiveTextfield: [{
            type: ViewChild,
            args: [TuiPrimitiveTextfieldComponent]
        }] }); })();
const ɵTuiInputCountDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TuiInputCountDirective);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiInputCountDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-input-count',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_HOST,
                        useExisting: forwardRef(() => TuiInputCountDirective_1)
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiInputCountModule, { declarations: function () { return [TuiInputCountComponent, TuiInputCountDirective]; }, imports: function () { return [CommonModule,
        TextMaskModule,
        TuiButtonModule,
        TuiPrimitiveTextfieldModule,
        TuiTextfieldControllerModule,
        TuiValueAccessorModule,
        PolymorpheusModule]; }, exports: function () { return [TuiInputCountComponent, TuiInputCountDirective, TuiTextfieldComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiInputCountModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TextMaskModule,
                    TuiButtonModule,
                    TuiPrimitiveTextfieldModule,
                    TuiTextfieldControllerModule,
                    TuiValueAccessorModule,
                    PolymorpheusModule,
                ],
                declarations: [TuiInputCountComponent, TuiInputCountDirective],
                exports: [TuiInputCountComponent, TuiInputCountDirective, TuiTextfieldComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { PASSWORD_ICON_DOWN, PASSWORD_ICON_UP, TUI_INPUT_COUNT_DEFAULT_OPTIONS, TUI_INPUT_COUNT_OPTIONS, TuiInputCountComponent, TuiInputCountDirective, TuiInputCountModule, tuiInputCountOptionsProvider };

//# sourceMappingURL=taiga-ui-kit-components-input-count.js.map